import { render, staticRenderFns } from "./Ayd.vue?vue&type=template&id=6807459d&scoped=true&"
import script from "./Ayd.vue?vue&type=script&lang=js&"
export * from "./Ayd.vue?vue&type=script&lang=js&"
import style0 from "./Ayd.vue?vue&type=style&index=0&id=6807459d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6807459d",
  null
  
)

export default component.exports